import puzzleData from '../pages/locationPage/puzzles/puzzleData'

function usePuzzleSetUp(location) {
    const locationPuzzles = puzzleData.[location]
    const puzzles = []
    const sceneTextDefaults = {
        office: "The Professor's office... but where is the Professor?",
        library: "A grand study room in the city Library",
        laboratory: "The Professor's laboratory. A place of science.",
        fourJokers: "The Four Jokers, meeting place for the New York underworld",
        lastStand: "A large warehouse down by the docks",
        machine: "Fix the error codes & get that needle back in the green!"
    }
    
    const defaultText = sceneTextDefaults.[location]

    class Puzzle {
        constructor({name, id, sceneText, specialIcon, puzzleVisible, puzzleLocked, component, cluesAvailable, clues}) {
            this.name = name
            this.id = id
            this.sceneText = sceneText
            this.specialIcon = specialIcon ? specialIcon : false
            this.puzzleVisible = puzzleVisible
            this.puzzleLocked = puzzleLocked
            this.component = component
            this.cluesAvailable = cluesAvailable
            this.clues = clues
            this.lastClueSent = -1
            this.isCompleted = false
        }
    }
    
    
    locationPuzzles.forEach(puzzle => {
        puzzles.push( new Puzzle(puzzle) )
    })
    
    return {puzzles, defaultText}
}

export default usePuzzleSetUp